import React from 'react';
import { Tooltip } from 'antd';
import { seriesColor, chrome } from '../../../analytics/vizTokens';

// Part-to-whole as a single horizontal stacked bar.
//
// Categorical hues are assigned in fixed order by entity index, never by rank, so
// filtering rows out does not repaint the survivors. Three of the categorical
// slots sit below 3:1 on a white surface, which under the relief rule obliges
// visible labels -- hence the legend below always carries the name AND the value,
// and every screen using this also renders the same numbers in a table.
function ShareBar({ rows, labelKey = 'name', valueKey = 'value', formatValue = (v) => v }) {
  const total = rows.reduce((a, r) => a + (Number(r[valueKey]) || 0), 0);
  if (!total) {
    return <div className="py-6 text-center text-sm text-muted">—</div>;
  }

  return (
    <div>
      <div
        className="flex h-6 w-full overflow-hidden rounded-md"
        style={{ backgroundColor: chrome.grid }}
      >
        {rows.map((row, i) => {
          const value = Number(row[valueKey]) || 0;
          const pct = (value / total) * 100;
          if (pct <= 0) return null;
          return (
            <Tooltip
              key={row[labelKey]}
              styles={{ root: { maxWidth: 'none' } }}
              title={(
                <div className="text-xs tabular-nums">
                  <div className="font-semibold">{row[labelKey]}</div>
                  <div>{formatValue(value)} · {pct.toFixed(1)}%</div>
                </div>
              )}
            >
              <span
                className="h-full cursor-help"
                style={{
                  width: `${pct}%`,
                  backgroundColor: seriesColor(i),
                  // 2px surface gap between adjacent fills.
                  boxShadow: `inset -2px 0 0 0 ${chrome.surface}`,
                }}
              />
            </Tooltip>
          );
        })}
      </div>

      <div className="mt-3 grid gap-x-6 gap-y-1.5 sm:grid-cols-2">
        {rows.map((row, i) => {
          const value = Number(row[valueKey]) || 0;
          const pct = (value / total) * 100;
          return (
            <div key={row[labelKey]} className="flex items-center gap-2 text-xs">
              <span
                className="inline-block h-2.5 w-2.5 shrink-0 rounded-sm"
                style={{ backgroundColor: seriesColor(i) }}
              />
              {/* Text stays in ink tokens; the swatch beside it carries identity. */}
              <span className="truncate text-ink">{row[labelKey]}</span>
              <span className="ml-auto shrink-0 font-semibold tabular-nums text-ink">
                {pct.toFixed(1)}%
              </span>
              <span className="w-24 shrink-0 text-right tabular-nums text-muted">
                {formatValue(value)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ShareBar;
